import axios from "axios";
import {
  getLoginUser,
  getBimPlanList,
  postBimPlanAdd,
  postBimPlanEdit,
  postBimPlanDelete,
  postBimPlanCopy,
  bimSimConstructGLeistt,
  bimSimConstructDeeelt,
  getSysNoticeReceived,
  getSysNoticeDetail,
  replicationScheme,
  clearUserCache,
  chbimLocalVisPage,
} from "../../api/api";
const ThemeChoose = () =>
  import("../../components/customize/themeChoose/ThemeChoose.vue");
// sceneList;
const importDataPage = () =>
  import("@/components/tables/Timeline/importDataPage.vue");

export default {
  name: "ProjectsList",
  components: {
    ThemeChoose,
    importDataPage,
  },
  data() {
    //避免XSS攻击，所以这里对参数取整。
    let page = parseInt(this.$route.query.page);
    //console.log('page' + page);
    if (isNaN(page) || page < 2) {
      page = 1;
    }
    return {
      // src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      src: require("../../assets/imgs/prod.jpeg"),
      form: {
        resource: "",
      },
      nowPage: page,
      totalPage: 1,
      projectInfoArr: [],
      userAccount: "",
      apps: [],
      appScenariosArr: [], //应用场景
      sceneId: null,
      sceneData: [],
      sceneList: false,
      sceneAdd: false,

      sceneListTitle: "",
      sceneListAdd: "添加",
      sceneForm: {
        name: "",
        remarks: "",
      },
      sceneFormLoading: false,
      sceneCardLoading: true,
      rules: {
        name: [
          { required: true, message: "请填写方案名称", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      simulationShow: false,
      simulationDataList: [],
      importDataPageShow: false,
      simulationLoading: false,
      onSubmitLoading: false,
      progressData: 0,
      statusType: "",
      posCode: window.sessionStorage.getItem("posCode"),
    };
  },
  mounted() {
    this.$store.commit("changePresentationModeState", false);
    window.sessionStorage.setItem("IsNew", "old");
    this.getLoginUser();
    if (this.$GLOBAL.projectBaseUrl.indexOf("localhost") == -1) this.notice();

    window.oncontextmenu = function () {
      return false;
    };

    let loginAccount = window.sessionStorage.getItem("loginAccount");
    if (loginAccount) {
      this.userAccount = loginAccount;
    }

    const projectInfoArr = JSON.parse(
      sessionStorage.getItem("projectInfoArrJson")
    );

    if (projectInfoArr && projectInfoArr.length > 0) {
      let parrLen = projectInfoArr.length;
      // console.log("数据源", projectInfoArr.projectAppList);
      this.appScenariosArr = [];
      projectInfoArr.forEach((item) => {
        this.appScenariosArr.push(item.projectAppDefault);
      });
      // this.appScenariosArr = new Array(projectInfoArr.length).fill("sandbox");
      let newArr = [];
      let index = 0;
      let pageNum = 8;
      this.totalPage = Math.ceil(parrLen / pageNum);
      for (let i = 0; i < parrLen; i++) {
        // //在列表数据展示前处理数据 (只展示创建时间)
        // if (projectInfoArr[i]["updatedTime"]) {
        //   projectInfoArr[i]["listShowTime"] = projectInfoArr[i][
        //     "updatedTime"
        //   ].slice(0, 10);
        // } else {
        //   if (projectInfoArr[i]["createdTime"]) {
        //     projectInfoArr[i]["listShowTime"] = projectInfoArr[i][
        //       "createdTime"
        //     ].slice(0, 10);
        //   }
        // }
        if (!projectInfoArr[i]["version"]) {
          projectInfoArr[i]["version"] = "V1.0.0";
        }
        if (!projectInfoArr[i]["avatar"]) {
          projectInfoArr[i]["avatar"] = require("../../assets/imgs/prod.jpeg");
        } else {
          projectInfoArr[i]["avatar"] =
            process.env.VUE_APP_LOCAL_RESOURCES_PATH +
            projectInfoArr[i]["avatar"];
        }
        if (i % pageNum === 0 && i !== 0) {
          // 截取整页数据部分。
          newArr.push(projectInfoArr.slice(index, i));
          index = i;
        }
        if (i + 1 === parrLen) {
          // 截取非整页部分。
          newArr.push(projectInfoArr.slice(index, i + 1));
        }
      }
      this.projectInfoArr = [projectInfoArr];

      // }
    } else {
      this.$alert("数据出错啦，请重新登录。", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        callback: (action) => {
          if (sessionStorage.getItem("IsNew") == "new") {
            window.location.href =
              process.env.VUE_APP_NEW_URL + "/projects/list";
          } else {
            this.$router.push({
              path: "/login",
            });
          }
        },
      });
    }
  },
  methods: {
    btnOK(data, idenStr = "", appScenarios, apps) {
      let layout = 0,
        pid = data.id;
      if (apps.find((e) => e.code == appScenarios).layout) {
        layout = 1;
      }
      window.sessionStorage.setItem("nowProjectId", pid);
      window.sessionStorage.setItem(
        "roadProjectId",
        data.roadProjectId ? data.roadProjectId : ""
      );
      window.sessionStorage.setItem("idenStr", idenStr);
      window.sessionStorage.setItem("appScenarios", appScenarios);
      window.sessionStorage.setItem("layout", layout);
      switch (appScenarios) {
        case "program":
          this.sceneData = [];
          // window.sessionStorage.setItem("nowProjectId", pid);
          this.sceneList = true;
          this.getBimPlanList(pid);
          break;
        case "sandbox_traffic":
          // 交组模拟
          this.simulationDataList = [];
          this.simulationShow = true;
          this.getSimulationList(pid);
          break;
        default:
          const projectInfoArr = JSON.parse(
            sessionStorage.getItem("projectInfoArrJson")
          );
          let indexProject = null;

          let stype = appScenarios;
          projectInfoArr.forEach((item) => {
            if (item.id == pid) {
              indexProject = item;
            }
          });
          const {
            lng,
            lat,
            alt,
            heading,
            pitch,
            maximumZoomDistance,
            minimumZoomDistance,
          } = indexProject;
          if (!lng && !lat && !alt && !heading && !pitch) {
            this.$router.push({
              name: "Index",
              params: {
                stype: stype,
                layout,
              },
            });
          } else {
            let indexProjectString = `${lng},${lat},${alt},${heading},${pitch},${maximumZoomDistance},${minimumZoomDistance}`;
            this.$router.push({
              name: "Index",
              params: {
                stype: stype,
                scenarioGroupId: 0,
                indexProjectString,
                layout,
              },
            });
          }
      }
      // 单机版埋点
      if (
        process.env.VUE_APP_PROJECT_BASE_URL.search("localhost") >= 0 ||
        process.env.VUE_APP_PROJECT_BASE_URL.search("127.0.0.1") >= 0
      ) {
        chbimLocalVisPage({
          userId: parseInt(window.sessionStorage.getItem("accountId")),
          projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        });
      }
    },
    getInto(item) {
      console.log(item);
      let indexProject = null;
      const projectInfoArr = JSON.parse(
        sessionStorage.getItem("projectInfoArrJson")
      );
      projectInfoArr.forEach((item) => {
        if (item.id == window.sessionStorage.getItem("nowProjectId")) {
          indexProject = item;
        }
      });
      const { lng, lat, alt, heading, pitch } = indexProject;
      if (!lng && !lat && !alt && !heading && !pitch) {
        this.$router.push({
          name: "Index",
          params: {
            stype: window.sessionStorage.getItem("appScenarios"),
            layout: window.sessionStorage.getItem("layout"),
            scenarioGroupId: item.id ? item.id : 0,
          },
        });
      } else {
        let indexProjectString = `${lng},${lat},${alt},${heading},${pitch}`;
        this.$router.push({
          name: "Index",
          params: {
            stype: window.sessionStorage.getItem("appScenarios"),
            layout: window.sessionStorage.getItem("layout"),
            scenarioGroupId: item.id ? item.id : 0,
            indexProjectString,
          },
        });
      }
    },
    getBimPlanList(pid) {
      this.sceneCardLoading = true;
      getBimPlanList({
        projectId: pid,
      })
        .then((res) => {
          this.sceneCardLoading = false;
          let { data, code } = res.data;
          this.sceneData = data;
          // that.recursionProjectShpInfo(ShpData);
        })
        .catch((error) => {
          console.log(error);
          this.sceneCardLoading = false;
          this.$notify({
            title: "查询失败，请稍后再试",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        // 添加
        if (valid) {
          this.sceneFormLoading = true;
          // 此处有个奇怪的问题 添加方案会根据所选的应用场景调用不同的接口 不是调整参数 请注意 每个新加的场景类型 都需要添加新接口
          if (this.sceneId) {
            postBimPlanEdit({
              projectId: window.sessionStorage.getItem("nowProjectId"),
              name: this.sceneForm.name,
              id: this.sceneId,
              isTop: this.sceneForm.isTop,
            })
              .then((res) => {
                let { code } = res.data;
                if (code == 200 || code == 204) {
                  this.sceneFormLoading = false;
                  this.sceneAdd = false;
                  this.$notify({
                    title: "保存成功",
                    message: "",
                    type: "success",
                    duration: 1000,
                    offset: 320,
                  });
                  this.getBimPlanList(
                    window.sessionStorage.getItem("nowProjectId")
                  );
                } else {
                  this.sceneFormLoading = false;
                  this.$notify({
                    title: "编辑数据失败",
                    message: "",
                    type: "error",
                    duration: 1000,
                    offset: 320,
                  });
                }
              })
              .catch((error) => {
                this.sceneFormLoading = false;
                this.$notify({
                  title: "编辑数据失败",
                  message: "",
                  type: "error",
                  duration: 1000,
                  offset: 320,
                });
              });
          } else {
            postBimPlanAdd({
              projectId: window.sessionStorage.getItem("nowProjectId"),
              name: this.sceneForm.name,
            })
              .then((res) => {
                let { code } = res.data;
                if (code == 200 || code == 204) {
                  this.sceneFormLoading = false;
                  this.sceneAdd = false;
                  this.$notify({
                    title: "添加成功",
                    message: "",
                    type: "success",
                    duration: 1000,
                    offset: 320,
                  });
                  this.getBimPlanList(
                    window.sessionStorage.getItem("nowProjectId")
                  );
                } else {
                  this.sceneFormLoading = false;
                  this.$notify({
                    title: "添加数据失败",
                    message: "",
                    type: "error",
                    duration: 1000,
                    offset: 320,
                  });
                }
                // that.recursionProjectShpInfo(ShpData);
              })
              .catch((error) => {
                this.sceneFormLoading = false;
                this.$notify({
                  title: "添加数据失败",
                  message: "",
                  type: "error",
                  duration: 1000,
                  offset: 320,
                });
              });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.sceneForm = {
        name: "",
        remarks: "",
      };
    },
    sceneAddFn() {
      this.resetForm("sceneForm");
      this.sceneListAdd = "添加";
      this.sceneForm = {
        name: "",
        remarks: "",
      };
      this.sceneAdd = true;
      this.sceneId = null;
    },
    sceneEditFn(item) {
      this.sceneListAdd = "编辑";
      let { name, isTop } = item;
      this.sceneForm = {
        name,
        isTop,
        remarks: "",
      };
      this.sceneAdd = true;
      this.sceneId = item.id;
    },
    sceneCloneFn(item) {
      this.sceneCardLoading = true;
      replicationScheme({
        id: item.id,
        projectId: window.sessionStorage.getItem("nowProjectId"),
      })
        .then((res) => {
          this.sceneCardLoading = false;
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getBimPlanList(window.sessionStorage.getItem("nowProjectId"));
            this.$notify({
              title: "复制成功",
              message: "",
              type: "success",
              duration: 1000,
              offset: 320,
            });
          } else {
            this.sceneCardLoading = false;
            this.$notify({
              title: "复制失败,请稍后再试",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          this.sceneCardLoading = false;
          this.$notify({
            title: "复制失败,请稍后再试",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    sceneToppingFn(item) {
      let { isTop, name, id } = item;
      postBimPlanEdit({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        name: name,
        id: id,
        isTop: !isTop,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.sceneFormLoading = false;
            this.sceneAdd = false;
            this.$notify({
              title: "保存成功",
              message: "",
              type: "success",
              duration: 1000,
              offset: 320,
            });
            this.getBimPlanList(window.sessionStorage.getItem("nowProjectId"));
          } else {
            this.sceneFormLoading = false;
            this.$notify({
              title: "编辑数据失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          this.sceneFormLoading = false;
          this.$notify({
            title: "编辑数据失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    sceneDeleteFn(item) {
      // this.sceneCardLoading = true;
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        modal: false,
      })
        .then(() => {
          this.sceneCardLoading = true;
          postBimPlanDelete({
            id: item.id,
            projectId: window.sessionStorage.getItem("nowProjectId"),
          })
            .then((res) => {
              this.sceneCardLoading = false;
              let { code } = res.data;
              if (code == 200 || code == 204) {
                this.getBimPlanList(
                  window.sessionStorage.getItem("nowProjectId")
                );
                this.$notify({
                  title: "删除成功",
                  message: "",
                  type: "success",
                  duration: 1000,
                  offset: 320,
                });
              } else {
                this.sceneCardLoading = false;
                this.$notify({
                  title: "删除失败,请稍后再试",
                  message: "",
                  type: "error",
                  duration: 1000,
                  offset: 320,
                });
              }
            })
            .catch((error) => {
              this.sceneCardLoading = false;
              this.$notify({
                title: "删除失败,请稍后再试",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            });
          // this.sceneCardLoading = false;
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消",
          // });
          this.sceneCardLoading = false;
        });
    },
    prePage() {
      if (this.nowPage >= 2) {
        if (this.nowPage < this.totalPage) {
          this.nowPage -= 1;
        } else {
          this.nowPage = this.totalPage - 1;
        }
      } else {
        this.nowPage = 1;
      }
      this.$router.push({
        path: "/projectsList",
        query: {
          page: this.nowPage,
        },
      });
      location.reload(); //刷新当前页面
    },
    getLoginUser() {
      clearUserCache({
        projectId: 0,
        application: "string",
      }).then((item) => {
        getLoginUser({
          appType: 1,
        }).then((resL) => {
          if (window.sessionStorage.getItem("accountId") != resL.data.data.id) {
            let { name, nickName, id, loginEmpInfo } = resL.data.data;
            if (window.xkCollectionSdk) {
              /**
               * 参数说明：
               * $_user_id: 用户id，应该根据所登录的用户动态获取其用户id， 如果不传递用户id，则会使用sdk自生成的唯一虚拟userid
               * $_app_key: 自定义个一个有语意的字符串即可
               * $_frontend_version: 接入项目的版本号，也就是你项目的版本号
               *  $_org_name: 试用单位，需要自己根据自己的业务情况动态获取，比如一个项目在A\B\C单位使用，不同单位就传不同单位的中文名称，默认中国交通信息科技集团有限公司
               */
              window.xkCollectionSdk.RunXkCollectionSdk({
                $custromData: {
                  $_user_id: id,
                  $_app_key: "chbim",
                  $_frontend_version: "v1.0",
                  $_org_name: loginEmpInfo.orgName,
                  $_user_name: name,
                },
              });
            }
          }

          if (resL.data.success && resL.data.data) {
            // let loginAccount = resL.data.data.account; //存放用户账户名。
            let loginAccount = resL.data.data.name; //（改为）存放用户真实姓名。
            if (loginAccount) {
              window.sessionStorage.setItem("loginAccount", loginAccount);
              window.sessionStorage.setItem(
                "posCode",
                resL.data.data.loginEmpInfo.positions[0].posCode
              );
              window.sessionStorage.setItem("accountId", resL.data.data.id);
              this.userAccount = loginAccount;
              this.posCode = resL.data.data.loginEmpInfo.positions[0].posCode;
            }
            if (this.apps) {
              this.apps = resL.data.data.apps;
              console.log(this.apps);
              if (this.apps.length == 0)
                this.$alert("请授权", "错误提示", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {
                    if (sessionStorage.getItem("IsNew") == "new") {
                      window.location.href =
                        process.env.VUE_APP_NEW_URL + "/projects/list";
                    } else {
                      this.$router.push({
                        path: "/login",
                      });
                    }
                  },
                });
            }
          }
        });
      });
    },

    notice() {
      getSysNoticeReceived({ appType: 1 }).then((res) => {
        if (res.data.success && res.data.data) {
          let { content, id, title } = res.data.data;
          this.$notify({
            title: "🎉 " + title,
            dangerouslyUseHTMLString: true,
            message: content,
            duration: 0,
            offset: 40,
          });
          getSysNoticeDetail({ id: id }).then((res) => {
            console.log(res);
          });
        }
      });
    },

    nextPage() {
      if (this.nowPage < this.totalPage) {
        //考虑到NaN之类的情况。
        if (this.nowPage) {
          this.nowPage += 1;
        } else {
          this.nowPage = 2;
        }
      } else {
        this.nowPage = this.totalPage;
      }
      this.$router.push({
        path: "/projectsList",
        query: {
          page: this.nowPage,
        },
      });
      location.reload(); //刷新当前页面
    },
    loginOut() {
      //退出功能
      //弹出确认对话框
      //用户点击确认，跳回用户登录页面，清除token
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
          //确认退出，清除token
          //window.sessionStorage.removeItem('token')
          window.sessionStorage.clear(); //退出后清空window.sessionStorage里的内容。
          //跳转登录页面(编程式导航)
          this.$router.push("/login");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    newScheme() {
      this.importDataPageShow = true;
    },
    getSimulationList(pid) {
      this.simulationLoading = true;
      bimSimConstructGLeistt({
        projectid: pid,
      }).then((res) => {
        this.simulationLoading = false;
        this.simulationDataList = res.data.data;
      });
    },
    deleteSimulation(item) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        modal: false,
      })
        .then(() => {
          this.simulationLoading = true;
          bimSimConstructDeeelt({
            simId: item.simId, //施工模拟Id
          })
            .then((res) => {
              this.simulationLoading = false;
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getSimulationList(
                window.sessionStorage.getItem("nowProjectId")
              );
            })
            .catch((error) => {
              this.simulationLoading = false;
              this.$notify({
                title: "删除失败,请稍后再试",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            });
          this.simulationLoading = false;
        })
        .catch(() => {
          this.simulationLoading = false;
        });
    },
    refreshGetSimulationList() {
      this.getSimulationList(window.sessionStorage.getItem("nowProjectId"));
    },
    toSimulation(item) {
      console.log(item);
      let indexProject = null;
      const projectInfoArr = JSON.parse(
        sessionStorage.getItem("projectInfoArrJson")
      );
      projectInfoArr.forEach((item) => {
        if (item.projectId == window.sessionStorage.getItem("nowProjectId")) {
          indexProject = item;
        }
      });
      // const { lng, lat, alt, heading, pitch } = indexProject;
      console.log(indexProject);
      console.log(window.sessionStorage.getItem("appScenarios"));
      window.sessionStorage.setItem("crossGroupSimId", item.simId);
      window.sessionStorage.setItem("cross_group_type", item.type);

      this.$router.push({
        name: "Index",
        params: {
          stype: window.sessionStorage.getItem("appScenarios"),
          layout: window.sessionStorage.getItem("layout"),
        },
      });
    },
    onSubmit() {
      this.$refs.importDataPage.onSubmit();
    },
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40;
      const $scrollWrapper = this.scrollWrapper;
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft - eventDelta / 4;
    },
    getTagArr(item) {
      if (item) {
        return item.split(",");
      }
      return [];
    },
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap;
    },
  },
};
